export const removeQueryParam = (paramName: string): void => {
  const params = new URLSearchParams(window.location.search);

  params.delete(paramName);

  const queryString = params.toString();
  const base = window.location.origin + window.location.pathname;

  window.history.replaceState(
    {},
    '',
    base + (queryString ? `?${queryString}${window.location.hash}` : window.location.hash)
  );
};
